/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DocumentTemplateCategory
 */
export interface DocumentTemplateCategory {
    /**
     * 
     * @type {string}
     * @memberof DocumentTemplateCategory
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentTemplateCategory
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof DocumentTemplateCategory
     */
    order?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentTemplateCategory
     */
    collapsed?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentTemplateCategory
     */
    active?: boolean;
}

/**
 * Check if a given object implements the DocumentTemplateCategory interface.
 */
export function instanceOfDocumentTemplateCategory(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function DocumentTemplateCategoryFromJSON(json: any): DocumentTemplateCategory {
    return DocumentTemplateCategoryFromJSONTyped(json, false);
}

export function DocumentTemplateCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentTemplateCategory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
        'order': !exists(json, 'order') ? undefined : json['order'],
        'collapsed': !exists(json, 'collapsed') ? undefined : json['collapsed'],
        'active': !exists(json, 'active') ? undefined : json['active'],
    };
}

export function DocumentTemplateCategoryToJSON(value?: DocumentTemplateCategory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'order': value.order,
        'collapsed': value.collapsed,
        'active': value.active,
    };
}

